(function () {
    "use strict";
  
    class ProductCustomComponent extends HTMLElement {
      constructor() {
        super();
      }
  
      static get observedAttributes() {
        return ["product"];
      }
  
      get product() {
        return this._product;
      }
  
      set product(value) {
        this._product = value;
        this.render();
      }
  
      connectedCallback() {
        if (this._product) {
          this.render();
        }
      }
  
      async render() {

        if (!this._product) return;

        // Initial render with product title
        this.innerHTML = `
          <h2 class="product-custom-component" tabindex="0" role="heading">
            ${this._product.title}
          </h2>
        `;

        // Get variant color from existing data
        if (this._product.variants && this._product.variants.length > 0) {
          const variant = this._product.variants[0];
          
          if (variant.selectedOptions) {
            const colorOption = variant.selectedOptions.find(option => 
              option.name.toLowerCase() === 'color'
            );
                        
            const colorName = colorOption ? colorOption.value : '';
            
            // Update with color information
            this.innerHTML = `
              <h2 class="product-custom-component" tabindex="0" role="heading">
                ${this._product.title}${colorName ? ' - ' + colorName : ''}
              </h2>
            `;
          }
        }
      }
    }
  
    customElements.define("rcc-product-titles", ProductCustomComponent);

    class ProductTitleNoBrand extends HTMLElement {
      set product(value) {
        this._product = value;
        this.render();
      }

      connectedCallback() {
        this.render();
      }

      render() {
        if (!this._product) return;

        const title = String(this._product.title || this._product.name || '').trim();
        const brand = String(this._product.brand || '').trim();
        const remainder = title.slice(brand.length);
        const startsWithBrand = brand &&
          title.slice(0, brand.length).toLocaleLowerCase() === brand.toLocaleLowerCase() &&
          (!remainder || /^[\s\-–—:|]/.test(remainder));
        const titleWithoutBrand = startsWithBrand
          ? remainder.replace(/^[\s\-–—:|]+/, '').trim() || title
          : title;

        this.hidden = !titleWithoutBrand;
        this.classList.add('rcc-search__product__title');
        this.setAttribute('role', 'heading');
        this.setAttribute('aria-level', '2');
        this.tabIndex = 0;
        this.textContent = titleWithoutBrand;
      }
    }

    if (!customElements.get('rcc-product-title-no-brand')) {
      customElements.define('rcc-product-title-no-brand', ProductTitleNoBrand);
    }
  })();
